export enum ReferenceType {
  MEETING = 'call',
  VIDEO = 'video',
  VIDEO_INTRODUCTION = 'intro',
  GOOGLE_MAPS = 'google-map',
  WEB_LINK = 'url',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}
